import { IParamsToSend } from '@base/@types/providers/Budget/parameters'

export const reportRequest: IParamsToSend = {
  ano: {
    ids: [],
    agrupar: false
  },
  mes: {
    ids: [],
    agrupar: false
  },
  fator: {
    ids: [],
    agrupar: false
  }
}
